<script>
import OrderForm from './Form'
import Roles from '@/mixins/Roles'
import isEqual from 'lodash.isequal'

import { mapGetters } from 'vuex'
export default {
    name: 'OrderFormGroup',

    components: { OrderForm },

    mixins: [Roles],

    data() {
        return {
            model: {},
            modelLoaded: false,
            loadingForm: [],
            forms: [],
        }
    },

    computed: {
        ...mapGetters({ services: 'services' }),

        userServices() {
            return this.authUser.services || []
            // .sort((a, b) => a.id > b.id ? 1 : -1)
            // return Object.keys(this.authUser.services || {}).map((key) => this.authUser.services[key]).sort((a, b) => a.id > b.id ? 1 : -1)
        },
    },

    watch: {
        services: {
            immediate: true,
            handler(value, oldValue) {
                if (!this.model.service || !this.model.service.id) {
                    this.$set(
                        this.model,
                        'service',
                        this.findService(this.model.service_id)
                    )
                }
                if (!isEqual(value, oldValue)) this.generateForms()
            },
        },
    },

    async mounted() {
        await this.$store.dispatch(
            'title',
            this.model?.id ? this.$t('ORDERS.EDIT') : this.$t('ORDERS.CREATE')
        )
        if (!this.hasRoleView('order.edit'))
            await this.$router.replace('/orders')
        if (this.$route.params.order)
            this.model = await this.$store.dispatch(
                'ordersFetchSingle',
                this.$route.params.order
            )
        else {
            let serviceId = 1
            if (!this.isAdmin()) {
                const services = this.userServices || []
                if (services && services.length) serviceId = services[0].id
            }
            this.$set(this, 'model', this.createModel(serviceId))
        }
        this.modelLoaded = true
        this.generateForms()
    },

    methods: {
        createModel(service_id, related, return_id) {
            return {
                id: null,
                service_id: service_id,
                customer_company_id: null,
                provider_company_id: null,
                passenger_name: null,
                passenger_phone: null,
                passenger_email: null,
                passenger_id: null,
                passenger_number: 1,
                luggage_number: '0',
                carry_on_luggage_number: '0',
                date: null,
                flightnumber: null,
                order_type_id: service_id == 3 ? 2 : 1,
                source_address_id: 1,
                addresses: [],
                provider_user_id: null,
                attachments: [],
                is_prepaid: false,
                custom_is_prepaid: null,
                modifiers: [],
                packet_id: null,
                price: 0,
                price_customer: 0,
                price_driver: 0,
                price_crm: 0,
                custom_price: null,
                custom_price_customer: null,
                custom_price_driver: null,
                custom_price_crm: null,
                customer_user_id: null,
                related_orders: [],
                related_order_id: related ? related : null,
                return_order: null,
                return_order_id: return_id ? return_id : null,
                service: {},
                order_status_id: 1,
                order_status_id_explicit: null,
                car_id: null,
                host_user_id: null,
                driver_comment: null,
            }
        },

        generateForms() {
            if (this.services?.length > 0) {
                this.forms = new Array()
                const currentService = this.findService(this.model.service_id)
                // Eredeti form
                if (!currentService) return
                const original = {
                    name: currentService.translated,
                    icon: currentService.icon,
                    return: false,
                    model: JSON.parse(JSON.stringify(this.model)),
                    has: !!this.model.id,
                    opened: this.model.id && !this.$route.params.retour,
                    disabled: false,
                }
                this.forms.push(original)
                // Return form
                const lastAddress =
                    this.model && this.model.addresses
                        ? this.model.addresses.slice(-1)[0]
                        : null
                const returnModel = Object.assign(
                    {},
                    this.createModel(this.model.service_id, null),
                    {
                        customer_company_id: this.model.customer_company_id,
                        passenger_name: this.model.passenger_name,
                        passenger_phone: this.model.passenger_phone,
                        passenger_email: this.model.passenger_email,
                        passenger_number: this.model.passenger_number,
                        luggage_number: this.model.luggage_number,
                        carry_on_luggage_number:
                            this.model.carry_on_luggage_number,
                        is_prepaid: this.model.is_prepaid,
                        order_type_id: this.model.order_type_id === 1 ? 2 : 1,
                        source_address_id:
                            lastAddress && lastAddress.id
                                ? lastAddress.id
                                : null,
                        addresses: this.model.source_address_id
                            ? [
                                  {
                                      id: this.model.source_address_id,
                                      address: 'Eredeti',
                                  },
                              ]
                            : [],
                        modifiers: this.model.modifiers,
                        packet_id: this.model.packet_id,
                        custom_packet_id: this.model.custom_packet_id,
                        return_order_id: this.model.id,
                    }
                )
                this.forms.push({
                    name: this.$t('ORDERS.RETURN_TRIP'),
                    icon: 'swap_calls',
                    return: true,
                    model: this.model.return_order
                        ? this.model.return_order
                        : returnModel,
                    has: !!this.model.return_order,
                    opened: !!this.$route.params.retour,
                    disabled: false,
                    should_save: !this.model.id,
                })
                for (let i = 0; i < this.services.length; ++i) {
                    const item = this.services[i]
                    const form = {
                        name: item.translated,
                        return: false,
                    }
                    if (this.model?.service_id === item.id) {
                        continue
                    } else {
                        let model = this.createModel(item.id, this.model.id)
                        form.has = false
                        if (
                            this.model.related_orders &&
                            this.model.related_orders.length
                        ) {
                            let related = this.model.related_orders.find(
                                (x) => x.service_id == item.id
                            )
                            if (related) {
                                model = JSON.parse(JSON.stringify(related))
                                form.has = true
                            }
                        }
                        form.disabled =
                            (this.model.service_id == 1 && item.id == 2) ||
                            (this.model.service_id == 2 && item.id == 1)
                        form.icon = item.icon
                        form.model = model
                    }
                    this.forms.push(form)
                }
                this.loadingForm = new Array(this.forms.length).fill(false)
            }
        },

        findService(id) {
            if (this.services)
                return this.services.find((service) => service.id === id)
            return {}
        },

        isResigned(index) {
            return this.forms?.[index]?.model?.order_status?.name === 'resigned'
        },

        async remove(id, index) {
            if (this.isResigned(index)) return
            await this.$store.dispatch('ordersSetStatus', {
                oid: id,
                target: 11,
            })
            const model = await this.$store.dispatch(
                'ordersFetchSingle',
                this.$route.params.order
            )
            this.$set(this.forms[index], 'model', model)
            this.modelLoaded = true
        },

        saveAndAddReturn() {
            for (let i = 0; i < this.forms.length; ++i) {
                const form = this.forms[i]
                if (form.opened) {
                    this.$store
                        .dispatch('ordersSave', form.model)
                        .then((res) => {
                            this.model = res.data
                            this.$router.push({
                                name: 'orders-edit-retour',
                                params: { order: res.data.oid, retour: true },
                            })
                        })
                }
            }
        },

        save(index, e) {
            e.preventDefault()
            e.stopPropagation()
            this.$set(this.loadingForm, index, true)
            this.$refs[`orderForm-${index}`]?.[0]?.check(false)
        },

        ready(index) {
            this.$set(this.loadingForm, index, false)
        },
    },
}
</script>

<template lang="pug">
div(v-if="model && model.service")
    acrm-panel.form-panel(
            collapse
            panel-id="main-transfer"
            v-for="(form, index) in forms"
            :key="form.name"
            :disabled="form.disabled"
            :opened="form.opened"
            :noOpenable="form.should_save"
            @active="form.opened = $event"
            @try-open="saveAndAddReturn")
        div.block-xs(slot="heading")
            acrm-heading(:level="4").flex-center-v
                icon(:name="form.icon" :class="{'rotate-90': form.return}").i-mn-n200.mr-2
                template(v-if="form.model.oid") {{ form.model.oid }}&nbsp;-&nbsp;
                | {{ $t('ORDERS.TRANS_DATA_HEAD', { type: form.name })}}
        template(slot="buttons")
            label.ml-auto.mb-0.mr-4.pr-1.font-weight-normal.h5(v-if="form.disabled") {{ $t('ORDERS.NOT_SELECTABLE')}}
                icon.ml-1(name="block")
            acrm-input-button.ml-auto(v-else-if="isResigned(index)" variant="danger" @click.stop="remove(form.model.oid, index)" link) {{ $t('ORDERS.REMOVED')}}
                acrm-badge.ml-1(icon="remove" variant="danger")
            acrm-input-button.ml-auto(v-else-if="form.has" variant="danger" @click.stop="remove(form.model.oid, index)" link) {{ $t('ORDERS.REMOVING')}}
                acrm-badge.ml-1(icon="remove" variant="danger")
            acrm-input-button.ml-auto(variant="success" v-else link) {{ $t('ORDERS.ADDING')}}
                acrm-badge.ml-1(icon="add" variant="success")
            acrm-input-button(
                v-if="hasRoleUpdate('orderlist.orders') || hasRoleView('order.edit')"
                variant="success"
                @click="save(index, $event)"
                @ready="ready(index)"
                :loading="loadingForm[index]"
                :disabled="loadingForm[index] || !form.opened"
                sm) {{$t('BASE.SAVE')}}

        acrm-order-condition(:serviceId="form.model.service_id" :active-status="form.model.order_status_id")
        order-form(:order="form.model" :ref="`orderForm-${index}`")
</template>
